import { createSlice } from '@reduxjs/toolkit';
import setCategoryLoadingReducer from 'store/category/reducer/setCategoryLoadingReducer';
import setCategoriesReducer from 'store/category/reducer/setCategoriesReducer';
import setCategoryFiltersReducer from 'store/category/reducer/setCategoryFiltersReducer';
import setCategoryIdReducer from 'store/category/reducer/setCategoryIdReducer';
import setCurrentCategoryReducer from 'store/category/reducer/setCurrentCategoryReducer';
import updateFilterAttributeOptionReducer from 'store/category/reducer/updateFilterAttributeOptionReducer';
import { CategoryState } from 'store/category/types';
import resetCategoriesReducer from './reducer/resetCategoriesReducer';
import setCategorySortByReducer from './reducer/setCategorySortByReducer';
import setCategoryPageNrReducer from './reducer/setCategoryPageNrReducer';
import setCategoryFiltersSelectionReducer from './reducer/setCategoryFiltersSelectionReducer';
import setCategoryRefetchFlagReducer from './reducer/setCategoryRefetchFlagReducer';
import setFetchedCategoryIdReducer from './reducer/setFetchedCategoryIdReducer';
import setRecentlyViewedProductsReducer from './reducer/setRecentlyViewedProductsReducer';
import setGtmPauseEventsReducer from './reducer/setGtmPauseEventsReducer';
import setGtmProductsDataReducer from './reducer/setGtmProductsDataReducer';
import resetCategoryFiltersReducer from './reducer/resetCategoryFiltersReducer';
import toggleActiveCategoriesReducer from './reducer/toggleActiveCategoriesReducer';
import resetToSingleCategoryReducer from './reducer/resetToSingleCategoryReducer';

export const categoryInitialState: CategoryState = {
  isLoading: true,
  categories: undefined,
  familiesOffset: 99999,
  filters: undefined,
  totalFamiliesFetched: 0,
  totalFamiliesAvailable: 0,
  categoryId: undefined,
  sortBy: 3,
  refetchFlag: true,
  gtmProductsData: {},
  gtmPauseEvents: false,
  activeCategories: [],
};

export const slice = createSlice({
  name: 'category',
  initialState: categoryInitialState,
  reducers: {
    setCategoryLoadingAction: setCategoryLoadingReducer,
    setCategoriesAction: setCategoriesReducer,
    setCategoryFiltersAction: setCategoryFiltersReducer,
    setCategoryIdAction: setCategoryIdReducer,
    setCategorySortByAction: setCategorySortByReducer,
    setCategoryPageNrAction: setCategoryPageNrReducer,
    setCurrentCategoryAction: setCurrentCategoryReducer,
    updateFilterAttributeOptionAction: updateFilterAttributeOptionReducer,
    resetCategoriesAction: resetCategoriesReducer,
    setCategoryFiltersSelectionAction: setCategoryFiltersSelectionReducer,
    setCategoryRefetchFlagAction: setCategoryRefetchFlagReducer,
    setFetchedCategoryIdAction: setFetchedCategoryIdReducer,
    setRecentlyViewedProductsAction: setRecentlyViewedProductsReducer,
    setGtmPauseEventsAction: setGtmPauseEventsReducer,
    setGtmProductsDataAction: setGtmProductsDataReducer,
    resetCategoryFiltersAction: resetCategoryFiltersReducer,
    toggleActiveCategoriesAction: toggleActiveCategoriesReducer,
    resetToSingleCategoryAction: resetToSingleCategoryReducer,
  },
});

export const {
  setCategoryLoadingAction,
  setCategoriesAction,
  setCategoryFiltersAction,
  setCategoryIdAction,
  setCurrentCategoryAction,
  updateFilterAttributeOptionAction,
  resetCategoriesAction,
  setCategorySortByAction,
  setCategoryPageNrAction,
  setCategoryFiltersSelectionAction,
  setCategoryRefetchFlagAction,
  setFetchedCategoryIdAction,
  setRecentlyViewedProductsAction,
  setGtmPauseEventsAction,
  setGtmProductsDataAction,
  resetCategoryFiltersAction,
  resetToSingleCategoryAction,
  toggleActiveCategoriesAction,
} = slice.actions;

const category = slice.reducer;
export default category;
